// https://css-tricks.com/building-progress-ring-quickly/
export function RingProgressBar({
	strokeColor,
	color,
	radius,
	stroke,
	progress,
	text,
}: {
	strokeColor: string;
	color: string;
	radius: number;
	stroke: number;
	progress: number;
	text?: string | number;
}) {
	const normalizedRadius = radius - stroke * 2;
	const circumference = normalizedRadius * 2 * Math.PI;
	const strokeDashoffset = circumference - (progress / 100) * circumference;

	return (
		<svg height={radius * 2} width={radius * 2} style={{ margin: -(radius / 4) }}>
			{/* Placeholder */}
			<circle
				stroke={strokeColor}
				fill="transparent"
				className="opacity-10"
				strokeWidth={stroke}
				r={normalizedRadius}
				cx={radius}
				cy={radius}
			/>
			{/* Bar */}
			<circle
				className="origin-center -rotate-90 transition-[stroke-dashoffset] duration-600"
				stroke={color}
				fill="transparent"
				strokeWidth={stroke}
				strokeDasharray={`${circumference} ${circumference}`}
				style={{ strokeDashoffset }}
				r={normalizedRadius}
				cx={radius}
				cy={radius}
			/>
			{text != null && (
				<text x="50%" y="50%" dominantBaseline="central" textAnchor="middle" fontSize="22" fill="rgb(var(--text))">
					{text}
				</text>
			)}
		</svg>
	);
}
